<div class="wrap-line-banner" @click="click"><img src="@/assets/LINE_Brand_icon.png"><span class="bold">{{ text }}</span></div>